<template>
  <div class="vim" v-on:click="handleSelect">
    <div class="imholder">
      <video-preview v-if="inView && mouseInside" :src="$k.imagebase + 'media/videos/' + video.video_id + '/clip.mp4'" />
      <ix-router-link :to="permalink">
        <transition name="fade">
          <img v-if="inView" class="tnail" :src="$k.imagebase + 'media/videos/' + video.video_id + '/thumbnail.jpg'"/>
        </transition>
      </ix-router-link>
    </div>
    <div class="me-contents">
      <div>
        <div class="artist-title" v-if="artist && !noartist">{{ artist.formatted_name }}</div>
        <div class="title">{{ video.title }}</div>
        <div class="summary">{{ video.summary }}</div>
      </div>
      <div class="social-panel">
        <social-panel url="url" media="media" message="message" :caption="video.title" />
      </div>
    </div>
  </div>
</template>

<script>
import ViewablePanel from '@/mixins/ViewablePanel.js'
import SocialPanel from '@/components/panels/SocialPanel.vue'
import VideoPreview from './VideoPreview.vue'

export default {
  props: {
    video: Object,
    noartist: Boolean
  },
  mixins: [ViewablePanel],
  components: {
    SocialPanel,
    VideoPreview
  },
  data () {
    return {
      mouseInside: false,
      permalink: '',
      artist: null
    }
  },
  created () {
    if(this.video) {
      this.init()
    }
  },
  mounted () {
    this.$el.addEventListener('mouseenter', this.handleMouseEnter)
    this.$el.addEventListener('mouseleave', this.handleMouseLeave)
  },
  methods: {
    async init () {
      let res = await this.$store.dispatch('fetchArtist', this.video.artist)
      if(res) {
        this.artist = res
      }
    },
    handleMouseEnter () {
      this.mouseInside = true
    },
    handleMouseLeave () {
      this.mouseInside = false
    },
    handleSelect(){
      this.$emit('select', this.video)
    }
  },
  watch: {
    video () {
      if(this.video){
        this.init()
      }
    },
    '$route.path': function () {
      this.setInView()
    }
  }
}
</script>

<style scoped>
.vim {
  width:32.5%;
  margin-bottom:1.3%;
  background-color:#fff;
  display:flex;
  flex-direction:column;
  cursor:pointer;
}

.vim img.tnail{
  position:absolute;
  top:50%;
  left:50%;
  transform: translate(-50%,-50%);
  width:115%;
  transition:all 0.3s ease;
  z-index:1;
}

.vim:hover img.tnail{
  width:125%;
}

.imholder{
  width:100%;
  height:0;
  padding-bottom:56.25%;
  overflow:hidden;
  position:relative;
  background-color:#fff;
}

.me-contents{
  padding:10px;
  display:flex;
  flex-direction:column;
  justify-content: space-between;
  flex-grow:1;
}

.me-contents .title{
  color:#8b6f4b;
  font-size:21px;
  font-weight:500;
}

.me-contents .artist-title{
  font-weight:700;
  margin:0 0 0.5em 0;
}

.vim:hover .me-contents .title{
  color:#ce0e2d;
}

.me-contents .summary{
  font-size:15px;
  color:#101820;
  margin-top:8px;
  margin-bottom:20px;
}

@media screen and (max-width:1100px) {
  .vim {
    width:49%;
  }
}

@media screen and (max-width:800px) {
  .vim {
    width:100%;
  }
}
</style>